/**
 * Temporary one-off entry point for the US2119019 Group 2 foundation diagnostic; replaced by the assistant panel work in
 * US2105994. Not a pattern for new features. It renders nothing in production and keys the control by the assistant
 * session (deal, dealer and user), so each context gets its own control state and a result from one context never shows in
 * another.
 */

// externals
import React from 'react';
import { useSelector } from 'react-redux';

// libraries
import { hostUrlHelper, locHrefUtil, MANAGER_VIEW_APP_PREFIX } from '@makemydeal/dr-shared-ui-utils';

// selectors
import * as compositeSelectors from '@makemydeal/dr-dash-store/selectors/compositeSelectors';

// components
import { AssistantConnectionDiagnosticControl } from './AssistantConnectionDiagnosticControl';

export const AssistantConnectionDiagnostic = () => {
    const sessionKey = useSelector(compositeSelectors.getAssistantSessionKey);

    if (hostUrlHelper.isProductionEnvironment(MANAGER_VIEW_APP_PREFIX, locHrefUtil.getLocHref())) {
        return null;
    }

    return <AssistantConnectionDiagnosticControl key={sessionKey} />;
};
